__turbopack_context__.v({
  "check": "cardLesson-module__q5j8rG__check",
  "content": "cardLesson-module__q5j8rG__content",
  "current": "cardLesson-module__q5j8rG__current",
  "divider": "cardLesson-module__q5j8rG__divider",
  "done": "cardLesson-module__q5j8rG__done",
  "dot": "cardLesson-module__q5j8rG__dot",
  "header": "cardLesson-module__q5j8rG__header",
  "headerTitle": "cardLesson-module__q5j8rG__headerTitle",
  "lessonSubtitle": "cardLesson-module__q5j8rG__lessonSubtitle",
  "lessonTitle": "cardLesson-module__q5j8rG__lessonTitle",
  "list": "cardLesson-module__q5j8rG__list",
  "root": "cardLesson-module__q5j8rG__root",
  "row": "cardLesson-module__q5j8rG__row",
  "status": "cardLesson-module__q5j8rG__status",
  "todo": "cardLesson-module__q5j8rG__todo",
});
